import { QueryFactory } from "../../../../Common";
export const QGetLeaguesByLeagueId = QueryFactory("GetLeaguesByLeagueId");
//# sourceMappingURL=QGetLeaguesByLeagueId.js.map